import { lazy } from 'react';

const Login = lazy(() => import('./pages/authentication/login'));
const IndividualHomePage = lazy(() =>
  import('./pages/authentication/registration/individual/home'),
);
const IndividualRolePage = lazy(() =>
  import('./pages/authentication/registration/individual/role'),
);
const CorporateHomePage = lazy(() =>
  import('./pages/authentication/registration/corporate'),
);
const RegistrationSuccess = lazy(() => import('./pages/success/registration'));
const Account = lazy(() => import('./pages/authentication/account'));
const EmailPasswordResetLink = lazy(() =>
  import('./pages/authentication/emailpasswordresetlink'),
);
const PasswordReset = lazy(() =>
  import('./pages/authentication/passwordreset'),
);

const authRoutes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/signup/individual',
    component: IndividualHomePage,
  },
  {
    path: '/signup/individual/role',
    component: IndividualRolePage,
  },
  {
    path: '/signup/corporate',
    component: CorporateHomePage,
  },
  {
    path: '/signup/success',
    component: RegistrationSuccess,
  },
  {
    path: '/signup/account',
    component: Account,
  },
  {
    path: '/email-password-reset-link',
    component: EmailPasswordResetLink,
  },
  {
    path: '/account/password/reset/:userId',
    component: PasswordReset,
  },
];

export default authRoutes;
